/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_OpenInputs */

const en_us2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join without a code`)
};

const pt_br2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar sem código`)
};

const es_419_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirse sin código`)
};

const pt_pt2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar sem código`)
};

const fr_fr2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre sans code`)
};

const de_de2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Code beitreten`)
};

const it_it2_clubs_field_open = /** @type {(inputs: Clubs_Field_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra senza codice`)
};

/**
* | output |
* | --- |
* | "Join without a code" |
*
* @param {Clubs_Field_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_open = /** @type {((inputs?: Clubs_Field_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_open(inputs)
	if (locale === "es-419") return es_419_clubs_field_open(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_open(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_open(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_open(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_open(inputs)
	return en_us2_clubs_field_open(inputs)
});
export { clubs_field_open as "clubs.field_open" }